import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { BusinesscoItem, LogisticService } from '../../../services/logistic.service';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';
import { TypeaheadService } from '../../../services/typeahead.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-activity-grid',
  templateUrl: './activity-grid.component.html',
  styleUrls: ['./activity-grid.component.css']
})
export class ActivityGridComponent implements OnInit {
    argType;

    argValue;

    public setting?: Setting;

    public selectListCompanies: BusinesscoItem[] = [];

    public selectListOks: OkItem[] = [];

    public grid?: GridOptions;

    constructor(private stateService: StateService, private datatask: DataTaskService, private logistic: LogisticService, private typeahead: TypeaheadService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadSetting() {
        if (!!this.argType && !!this.argValue) {
            this.setting = (await this.datatask.Post(2451, {
                argtype: this.argType,
                argvalue: this.argValue
            }))[0];
        }
    }

    private async loadCompanies() {
        this.selectListCompanies = await this.logistic.getCompanies();
    }

    private async loadOks() {
        this.selectListOks = await this.datatask.Post(1418);
    }

    private loadGrid() {
        if (!!this.setting) {
            if (!this.grid) {
                this.grid = new Grid()
                    .setRememberId(this.setting?.view_id)
                    .setLoadDataFunction({
                        method: this.setting?.p2_datatask_keyno,
                        parameters: this.setting
                    })
                    .setKendoConfig({ height: '100%' })
                    .setToolbar({ wrapping: true });
            } else {
                this.grid?.gridfunc?.read();
            }
        }
    }

    public searchCustomerNames = () => {
        return this.typeahead.searchCustomer({
            cust_name: this.setting?.cust_name ?? '',
            custtype: 'C',
            lastselect: 'SEARCH'
        });
    }

    public onCustomerNameSelected(item?: Item) {
        if (!!this.setting) {
            this.setting.cust_no = item?.item_id ?? '0';
            this.setting.cust_name = item?.item_name ?? '';

            this.loadGrid();
        }
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'custactedit1':
                this.stateService?.go('custactedit', {
                    custact_no: '0',
                    filterfield: '-',
                    filtervalue: '-'
                });
                break;
            case 'custactedit2':
                this.stateService?.go('custactedit', {
                    custact_no: '0',
                    filterfield: 'cust_no',
                    filtervalue: this.setting?.cust_no
                });
                break;
            default:
                break;
        }
    }

    public onChanged(_: string, id: keyof Setting) {
        switch (id) {
            case 'businessco_no':
            case 'ok':
                if (!!this.setting) {
                    if (this.setting[id]) this.loadGrid();
                }
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadCompanies();
        this.loadOks();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    cust_no: string | number;
    cust_name: string;
    ok: string;
    argtype: string;
    argvalue: string;
    p2_datatask_keyno: number;
    view_id: string;
    businessco_no: string;
}

interface OkItem {
    ok: string;
    ok_name: string;
}
